import { render } from "./TakeLogo.vue?vue&type=template&id=4de3cb2a&scoped=true&ts=true"
import script from "./TakeLogo.vue?vue&type=script&lang=ts"
export * from "./TakeLogo.vue?vue&type=script&lang=ts"

import "./TakeLogo.vue?vue&type=style&index=0&id=4de3cb2a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4de3cb2a"]])

export default __exports__